module.exports = __webpack_public_path__ + "img/edit_img.a30cd65b.png";